import { Component, Input } from '@angular/core';


import { ShIconModule } from '../../../../../elements/public_api';
import { ShBaseCell } from '../_base/base-cell.component';
import { CheckCell } from './check-cell.entity';

@Component({
    standalone: true,
    selector: 'sh-check-cell',
    templateUrl: './check-cell.component.html',
    imports: [ShIconModule]
})
export class ShCheckCellComponent extends ShBaseCell {
    @Input() public cell!: CheckCell;
}
